import {formatCurrency, parseCurrency} from "../../utils/i18n";
import {formattedDate} from "../../utils/dateFormat";
import React from 'react';

export default ({amount, buttonText, customer}) => parseCurrency(amount) > 0 && <div className={'payment-nacha'}>
  I authorize {customer.long_name} to charge my account
  on or after {formattedDate(Date.now())} as a one-time payment of {formatCurrency(amount)}.
</div>;